import React from 'react';
import { Check } from '../FormControls';
import { policyWord as p } from '../../domain/studioSettings';
import s from './settings.module.css';

// Business Settings → Family Portal (#774): MMS's Student Portal tab, which
// sits after Policies. Drawn only while the Family Portal is open (#769,
// SettingsPage.jsx).
//
// Its Visibility group, four of MMS's six boxes: what a family sees of the
// studio in the portal. `familyPortalView` reads them (functions/portal/
// view.js). MMS's values, why the other two and MMS's Permissions and
// Customization are not here, and the words, are the core's
// (`PORTAL_VISIBILITY_GROUP` in core/src/settings.rs); a studio that never
// ticks anything here writes nothing and reads as MMS.
//
// Saved on change, like every Business Settings panel (SettingsPage.jsx),
// each `onChange` naming only the leaf that changed.
export default function FamilyPortalSettingsPanel({ visibility, onChange }) {
  const box = (leaf, label, help) => (
    <Check
      checked={visibility[leaf]}
      onChange={(e) => onChange({ [leaf]: e.target.checked })}
      label={p(label)}
      help={help ? p(help) : undefined}
    />
  );
  return (
    <div className={s.panel}>
      <div className={s.panelTitle}>{p('portalVisibility')}</div>
      <div className={s.groupHelp}>{p('portalVisibilityBlurb')}</div>
      <div className={s.group}>
        {box('allAttendees', 'showAttendeesCheck', 'showAttendeesHelp')}
        {box('teacherEmailPhone', 'showTeacherContactCheck')}
        {box('teacherAddress', 'showTeacherAddressCheck')}
        {box('makeupCredits', 'showMakeupCreditsCheck')}
      </div>
    </div>
  );
}
